export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBoE3zW3x6ihwnNNj52Bw0QQr6_44pyu64',
    authDomain: 'duestracker-2020.firebaseapp.com',
    databaseURL: 'https://duestracker-2020.firebaseio.com',
    projectId: 'duestracker-2020',
    storageBucket: 'duestracker-2020.appspot.com',
    messagingSenderId: '438874023319',
    appId: '1:438874023319:web:0b0b5253f8bb5fa8',
  },
  dbApi: {
    baseUrl: 'https://api-demo.duesplus.com/api'
  },
  stripe: {
    public_key: 'pk_test_N2rWfiuApD4Qe0hHl4jyoN85',
  },
  featureFlags: {
    messages: true,
    attendance: true,
    voting: false,
    budgetTools: true,
  },
  // Duesy ? help menu. Empty links are hidden. TODO: set the real URLs.
  duesy: {
    helpLinks: {
      helpCenter: '',
      trainingVideos: '',
      releaseNotes: '',
      contactSupport: '',
    },
  },
  area: 'test',
};
